import React from "react";
import { Box, Fade } from "@material-ui/core";
import Details from "./Details";

/**
 * AcceptedLeadsType - A reusable warning/info box component with a triangular pointer
 *
 * @param {Object} props
 * @param {string} props.title - The bold heading text (optional)
 * @param {string} props.message - The main message content
 * @param {boolean} props.showPointer - Whether to show the triangular pointer (default: true)
 * @param {number} props.pointerPosition - Left position of pointer in pixels (default: 20)
 * @param {number} props.marginTop - Top margin in pixels (default: 16)
 * @param {string} props.variant - Color variant: 'warning' (orange) or 'info' (blue) (default: 'warning')
 */
const AcceptedLeadsType = ({
  showAcceptedLeadsTypeMessage,
  value,
  franchise,
  showOrgBox,
}) => {
  return (
    <Box sx={{ maxWidth: showOrgBox ? "70%" : "100%" }}>
      <Fade in={showAcceptedLeadsTypeMessage}>
        <Box
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            padding: 14,
            backgroundColor: "#fff8e1",
            border: "1px solid #ffb74d",
            borderLeft: "4px solid #ff9800",
            borderRadius: 6,
            boxShadow: "0 2px 4px rgba(255, 152, 0, 0.08)",
            marginTop: 16,
          }}
        >
          <Box
            style={{
              position: "absolute",
              top: -8,
              left: 20,
              width: 0,
              height: 0,
              borderLeft: "8px solid transparent",
              borderRight: "8px solid transparent",
              borderBottom: "8px solid #ffb74d",
            }}
          />
          <Box
            style={{
              position: "absolute",
              top: -7,
              left: 20,
              width: 0,
              height: 0,
              borderLeft: "8px solid transparent",
              borderRight: "8px solid transparent",
              borderBottom: "8px solid #fff8e1",
            }}
          />
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Details franchise={franchise} value={value} />
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

export default AcceptedLeadsType;
